module.exports = __webpack_public_path__ + "img/__icon_STANDARD.0fffcedb.svg";